const OPEN_DATASETS_KEY = 'swa.openDatasets';

/** The route project, or the one saved project after a reload of the app home. */
export function projectToActivate(routeDatasetId, storedIds) {
	if (routeDatasetId) {
		return String(routeDatasetId);
	}
	const ids = (storedIds || []).map(id => String(id)).filter(Boolean);
	return ids.length === 1 ? ids[0] : '';
}

export const readStoredOpenDatasets = () => {
	if (typeof sessionStorage === 'undefined') {
		return [];
	}
	try {
		const parsed = JSON.parse(sessionStorage.getItem(OPEN_DATASETS_KEY) || '[]');
		if (!Array.isArray(parsed)) {
			return [];
		}
		const ids = [...new Set(parsed.map(id => String(id)).filter(Boolean))];
		return ids.length ? [ids[ids.length - 1]] : [];
	} catch {
		return [];
	}
};

export const persistOpenDatasets = openDatasets => {
	if (typeof sessionStorage === 'undefined') {
		return;
	}
	sessionStorage.setItem(OPEN_DATASETS_KEY, JSON.stringify(openDatasets));
};

export const openDataset = datasetId => ({
	type: 'OPEN_DATASET',
	datasetId: datasetId == null ? null : String(datasetId)
});

export const closeDataset = datasetId => ({
	type: 'CLOSE_DATASET',
	datasetId: datasetId == null ? null : String(datasetId)
});
